import initialState from './initialState';
import Immutable from 'immutable';
import createReducer from './createReducer';
import * as statusActions from 'actions/statusActions';
import * as workOrderActions from 'actions/workOrderActions';

const uuidV4 = require('uuid/v4');

const setErrorToDefault = (state) => {
    return state.set('currentErrors', new Immutable.List());
};

const setMessageSendError = (state) => {
    return state.set('currentErrors', state.get('currentErrors').push(Immutable.fromJS({ errorMessage: 'Sending message failed', id: uuidV4() })));
};

const setSqcError = (state, action) => {

    let message = '';
    if (action.payload && action.payload.status === 400) {

        if (action.payload.xhr.responseText.indexOf('One or more errors occurred') !== -1) {
            message = 'Cable Medic Connection Error';
        } else if (action.payload.xhr.responseText.indexOf('instance of an object') !== -1) {
            message = 'MAC Address Not Found';
        } else if (action.payload.xhr.responseText.indexOf('Invalid Request') !== -1) {
            message = 'Invalid Request';
        } else {
            message = 'Getting Levels Failed';
        }
    } else if (action.payload && action.payload.status === 404) {
        message = 'MAC Address Not Found'
    } else {
        message = 'Getting Levels Failed';
    }

    state = state.setIn([
        'workOrderDetails', action.orderId, 'sqcResults', 'loading'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'sqcResults', 'bypassBecauseOfFailure'
    ], true);

    return state.set('currentErrors', state.get('currentErrors').push(Immutable.fromJS({ errorMessage: message, id: uuidV4() })));
};

const setOrderCloseFailed = (state) => {
    const userId = state.getIn(['user', 'userId']);

    const channels = [userId];
    statusActions.getTechStatusStarted({
        techStatusChange: {
            userId: userId,
            techStatusWorkOrder: {
                workOrderNumber: null,
                arrivalTime: null
            },
            techStatus: "GetStatus"
        },
        channels: channels
    }, userId);
    workOrderActions.workOrderGetTechRouteStarted({ userId: userId, isSelf: true });

    return state.set('currentErrors', state.get('currentErrors').push(Immutable.fromJS({ errorMessage: 'Completing the order failed', id: uuidV4() })));
};

const setWorkOrderSearchError = (state, action) => {
    let errorMessage = 'Something went wrong searching for orders. Please try again.';
    if (action.payload && action.payload.status === 401) {
        errorMessage = 'You are not authorized to search for work orders.';
    }
    return state.set('currentErrors', state.get('currentErrors').push(Immutable.fromJS({ errorMessage: errorMessage, id: uuidV4() })));
};

const removeError = (state, action) => {
    const errorIndex = state
        .get('currentErrors')
        .findIndex((errorItem) => {
            return errorItem.get('id') === action.id;
        });

    if (errorIndex > -1) {
        return state.set('currentErrors', state.get('currentErrors').remove(errorIndex));
    }
    return state;
};

const rehydrate = (state, action) => {
    if (action.payload.error) {
        state = action.payload.error;
    }
    return state.set('stateReady', true);
};

/**
 *
 * @param {*} state
 * @param {*} message
 * @param {*} autoHideDuration null by default (never hide) or milliseconds to auto hide
 * @returns
 */
const showInfo = (state, message, autoHideDuration = null) => {
    const error = Immutable.fromJS({
        errorMessage: message,
        id: uuidV4(),
        type: 'info',
        autoHideDuration
    });
    const newErrors = state.get('currentErrors').push(error);
    return state
        .set('currentErrors', newErrors);
};

/**
 *
 * @param {*} state
 * @param {*} message
 * @param {*} autoHideDuration null by default (never hide) or milliseconds to auto hide
 * @returns
 */
const showError = (state, message, autoHideDuration = null) => {
    const error = Immutable.fromJS({
        errorMessage: message,
        id: uuidV4(),
        type: 'error',
        autoHideDuration
    });
    const newErrors = state.get('currentErrors').push(error);
    return state
        .set('currentErrors', newErrors);
};

const errorHandlers = {
    'WORK_ORDER_SEARCH_STARTED': setErrorToDefault,
    'WORK_ORDER_SEARCH_FAILED': setWorkOrderSearchError,
    'REMOVE_ERROR': removeError,
    'persist/REHYDRATE': rehydrate,
    'SQC_GENERATE_FAILED': setSqcError,
    'ORDER_CLOSE_FAILED': setOrderCloseFailed,
    'ASURION_PLUS_ENROLLMENT_SUBMIT_FAILED': (state, action) => showError(state, action.payload.message || 'Could not send enrollment communication. Try again later.'),
    'ASURION_PLUS_ENROLLMENT_SUBMIT_FINISHED': (state, action) => showInfo(state, 'Enrollment communication sent.'),
};

export default createReducer(initialState.get('error'), errorHandlers);



// WEBPACK FOOTER //
// ./src/reducers/errorReducer.js